import { fetchdata } from 'apis/FetchData';
import { apiConfig, appConfig } from 'config';

const getHeaders = () => {
  const auth = window.__APP_AUTH;

  return {
    Accept: '*application/json*',
      'cache-control': 'no-cache',
    Origin: `${appConfig.webBaseUrl}/`,
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };
};

//first layer for fetching historical logs
export function retrieveEventLog(deviceId) {
  return fetchdata(apiConfig.cmServiceRetrieveEventLog(deviceId), {
    method: 'POST',
    headers: getHeaders(),
    mode: 'cors'
  });
}

//first layer for fetching live logs
export function pathcDeviceById(deviceId, active = 'full') {
  let body = {
    parameters: {
      eventLogging: {
        sendToIbms: active,
        PM_update_interval: 1
      }
    }
  };
  return fetchdata(apiConfig.cmServicePatchDeviceById(deviceId), {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers: getHeaders(),
    mode: 'cors'
  });
}

//second layer for both fetching historical and live logs
export function fetchRuntimeStatus(endpoint) {
  return fetchdata(endpoint)
    .then((res) => res)
    .catch((error) => console.error(error));
}

//third layer for fetching historical logs
export function fetchHistoricalEventLogs(deviceId, from = 0, size = 20, sortBy = 'timestamp', order = 'desc') {
  let body = {
    deviceId,
    from,
    size,
    sortBy,
    order
  };

  return fetchdata(apiConfig.logServiceEventlog, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: getHeaders(),
    mode: 'cors'
  })
    .then((result) => {
      return result && result.results ? result.results : [];
    })
    .catch((error) => console.log('From fetchHistoricalEventLogs: ', error));
}

//third layer for fetching live logs
export function fetchLiveEventLogs(deviceId, from = 0, size = 20, sortBy = 'timestamp', order = 'desc') {
  let body = {
    deviceId,
    from,
    size,
    sortBy,
    order
  };

  return fetchdata(apiConfig.logServiceSearch, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: getHeaders(),
    mode: 'cors'
  })
    .then((result) => {
      return result && result.events ? result.events : [];
    })
    .catch((error) => console.log('From fetchLiveEventLogs: ', error));
}
